module.exports = __webpack_public_path__ + "static/media/mursion-navbar-logo.270b7142.png";